import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {Col} from "react-bootstrap";
import {changeView, toggleLoader} from "../../shared/actions/setting";
import {REPORT_NAMES, VIEW} from "../../shared/util/enum";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {getUserId} from "../../shared/authentication/authentication";
import {toast} from "react-toastify";
import {useHistory, useParams} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import * as d3 from "d3";
import C3Chart from "react-c3js"
import {  generateGraphStructure } from "../../shared/util/report-graphs-generator";
import { dateFormat } from "../../shared/util/utils";
import { generateReportCSVStructure } from "../../shared/util/report-csv-generator";

const Graph = ({graphData, loadGraph, graphStyle }) =>{
    return <div className="chart p-2 mb-5 rounded border">
        {loadGraph && graphData.data && (
            <C3Chart 
                area={{zerobased: false}} 
                padding={{left:75}} 
                style={{height:460}} 
                tooltip={graphData.tooltip} 
                zoom={graphData.zoom}
                data={graphData.data} 
                subchart={{show: false}} 
                onrendered={graphStyle} 
                axis={graphData.axis}
            />
        )}
    </div>
}

const MachinePerformanceGraph = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {machineID} = useParams();
    const {departmentID} = useParams();
    const {performance} = useParams();
    const [loadGraph, setLoadGraph] = useState(false);
    const [graphDataSet, setGraphDataSet] = useState({});
    const [aggregatedHistory, setAggregatedHistory] = useState([]);
    const [isExportView, setIsExportView] = useState(true);
    const [isRenderingMultiGraphs, setIsRenderingMultiGraphs] = useState(false);
    // react-c3js only reloads series on update, so remount charts to apply new categories, groups and axis labels
    const [graphVersion, setGraphVersion] = useState(0);
    const selectedGraphType = useSelector(state => {
        return state.reportList.selectedGraphType;
    });
    const selectedShiftTypeGraph = useSelector(state => {
        return state.reportList.selectedShiftTypeGraph;
    });
    const selectedReportType = useSelector(state => {
        return state.reportList.selectedReportType;
    });
    const todayDate = dateFormat(new Date());
    const fromDate = selectedReportType ? selectedReportType.fromDate : todayDate;
    const toDate = selectedReportType ? selectedReportType.toDate : todayDate;

    useEffect(() => {
        dispatch(changeView(VIEW.GRAPH_LIST));
    }, []);

    function styleGraph() {
        if (window.innerWidth < 769) {
            console.log("inside styling chart");
            d3.select(".c3-axis-x-label").attr("dy", "42px");
            d3.selectAll(".tick").style("font-size", "7px");
            d3.select(".c3-axis-y-label").attr("dy", "-60px");
        } else {
            d3.select(".c3-axis-y-label").attr("dy", "-60px");
        }
        d3.selectAll(".c3-legend-item").attr("x", "400");

    }

    useEffect(() => {
        if (aggregatedHistory.length === 0) {
            setIsExportView(false);
        }
    }, [aggregatedHistory]);

    async function addDataGraph(graphData) {
        await new Promise((resolve, reject) => {
            resolve(1); 
            setGraphDataSet(graphData);
            setGraphVersion(version => version + 1);
        });
    }

    useEffect(() => {
        if (!aggregatedHistory || aggregatedHistory.length === 0) {
            return;
        }

        if(performance === REPORT_NAMES.UTILIZATION){
            setIsRenderingMultiGraphs(true);
            const graphOne = generateGraphStructure(aggregatedHistory, performance, "capacity");
            const graphTwo = generateGraphStructure(aggregatedHistory, performance, "time");
            addDataGraph([graphOne, graphTwo]).then(() => {
                setLoadGraph(true);
            });

        } else if(performance === REPORT_NAMES.AVERAGE_ORDER_SIZE) {
            setIsRenderingMultiGraphs(true);
            const graphOne = generateGraphStructure(aggregatedHistory, performance, "orderSize");
            const graphTwo = generateGraphStructure(aggregatedHistory, performance, "colors");
            const graphThree = generateGraphStructure(aggregatedHistory, performance, "length");
            addDataGraph([graphOne, graphTwo, graphThree]).then(() => {
                setLoadGraph(true);
            });
        } else{
            const graphData = generateGraphStructure(aggregatedHistory, performance); 
            addDataGraph(graphData).then(() => {
                setLoadGraph(true);
            });
            setIsRenderingMultiGraphs(false);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aggregatedHistory,selectedGraphType]);

    useEffect(() => {
        if(!selectedGraphType)
        {
            setAggregatedHistory([]);
            setIsExportView(false)
            return;
        }

        let REPORT_URL = process.env.REACT_APP_HOST + 'user/' + getUserId() + '/machine/'+ machineID +'/' + performance + `/graph?shift=` + selectedShiftTypeGraph;
        
        if(selectedGraphType === "CUSTOM"){
            REPORT_URL = REPORT_URL +`&reportType=CUSTOM&from=` + fromDate + '&to=' + toDate;
        }else{
            REPORT_URL = REPORT_URL +`&reportType=` + selectedGraphType;
        }

        // Ignore responses from requests made with outdated filters or for a previous machine
        let isStale = false;
        dispatch(toggleLoader(true));
        axios.get(REPORT_URL)
            .then(res => {
                if (isStale) {
                    return;
                }
                setIsExportView(true)
                setAggregatedHistory(res.data.content);
            }).catch(error => {
                if (isStale) {
                    return;
                }
                if (error.response && error.response.status === 422) {
                    toast.error(error.response.data.message);
                }
                setAggregatedHistory([])
            }
        ).finally(() => {
            // A newer request owns the loader once this one is stale
            if (!isStale) {
                dispatch(toggleLoader(false))
            }
        })

        return () => {
            isStale = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machineID,selectedGraphType,selectedShiftTypeGraph,selectedReportType]);

    function exportData() {
        const type = performance === REPORT_NAMES.UTILIZATION ? 'machineUtilization' : performance;
        generateReportCSVStructure(aggregatedHistory,type);
    }

    function goToTableView() {
        history.push('/' + departmentID  + '/' + machineID + '/'+ performance+ "/performanceTable");
    }

    return (
        <div id="listView" className={'list-view'}>
            <div className={"half-list-container margin-view-report"}>
                <Container>
                    <div className="single-card p-a-16 graph-container">
                        <div className="d-flex justify-content-end pb-4">
                            <button onClick={goToTableView}   className="graph-report-btn pis-add" style={{ padding: '8px 10px' }}>
                                    <FeatherIcon  className="trend-icon" icon="credit-card" /> <span className={"desktop-show"}>Table View</span>
                            </button>
                            {isExportView &&
                            <button className=" btn btn-sa-secondary-export-graph pis-add"
                                    disabled={aggregatedHistory.length===0}
                                    onClick={exportData}
                            >
                                <FeatherIcon className="spy-export-icon" icon="download" /> <span className={"desktop-show"}>EXPORT</span>
                            </button>
                            }
                        </div>
                        <div id="scrollableDiv" className="table-container-varna-graph">
                            <Col xl={12} lg={12} md={12} sm={12}>
                                <div className="row participant-graph">
                                    <div className="text-center padding-f card-summary-box-machine-performance-graph">
                                        <div className="machinePerformanceChart">
                                            {
                                                aggregatedHistory.length !== 0 && isRenderingMultiGraphs ? 
                                                <>
                                                    {
                                                        graphDataSet.map((item,index) =>{
                                                            return <Graph key={graphVersion + '-' + index} graphData={item} loadGraph={loadGraph} graphStyle={styleGraph}/>
                                                        })
                                                    }
                                                </> 
                                                :aggregatedHistory.length !== 0 ?
                                                    <Graph key={graphVersion} graphData={graphDataSet} loadGraph={loadGraph} graphStyle={styleGraph}/>
                                                :<div className={"empty-results"}>
                                                    <FeatherIcon icon="info"/>
                                                    <div className={"empty-results-text"}>There are no data</div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </div>
                </Container>
            </div>
        </div>

    )
};


export default MachinePerformanceGraph;
